import usePrivateAxios from "@/common/api/usePrivateAxios";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { EquipmentModelLatestFipeData, EquipmentModelLatestFipeResponse } from "../types/equipmentModelLatestFipe";

const useEquipmentModelLatestFipe: (id: string) => UseQueryResult<EquipmentModelLatestFipeData, unknown> = (id) => {
  const privateAxios = usePrivateAxios()

  return useQuery<EquipmentModelLatestFipeResponse, unknown, EquipmentModelLatestFipeData>({
    queryKey: ['equipmentModelLatestFipe', id],
    queryFn: () => privateAxios.get(`/equipment_models/${id}/latest_fipe`),
    select: (data) => data?.data?.data
  });
}

export default useEquipmentModelLatestFipe